import Box from '@mui/material/Box';
import { Grid, Container } from '@mui/material';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import CountrySelect from '../../common/Selects/CountrySelect';
import intl from 'components/i18n/ReactIntlWrapper';
import DatePickerDialog from '../../common/DatePickerDialog';
import { uniformizeDate } from 'common/utils';
import ErrorSummary from 'components/common/ErrorSummary';

const CalendarEventForm = ({ errors, input, handleCountryChange, selectedCountry, countries, handleInputChange, handleDate }) => {

    // Helper function to create label with error handling
    const renderLabel = (labelText, errorKey) => (
        <Typography 
            component="label" 
            sx={{ 
                display: 'block', 
                mb: 1, 
                color: errors[errorKey] ? 'error.main' : 'text.primary'
            }}
        >
            {labelText} {errors[errorKey] && (
                <Typography component="span" color="error">
                    {errors[errorKey]}
                </Typography>
            )}
        </Typography>
    );
    return (
        <Box component="form" sx={{ width: '100%' }}>
            <Box sx={{ mb: 2 }}>
                <Grid size={{xs:12}}>
                    <ErrorSummary errors={errors} showEverything={true} />
                </Grid>
            </Box>

            <Box sx={{ mb: 2 }}>
                {renderLabel(intl.get('calendarEventForm.country'), 'idCountry')}
                <FormControl fullWidth>
                    <CountrySelect
                        handleCountryChange={handleCountryChange}
                        selectedCountry={selectedCountry}
                        countries={countries}
                        inputCountry={input.country.name}
                    />
                </FormControl>
            </Box>
            <Box sx={{ mb: 2 }}>
                {renderLabel(intl.get('calendarEventForm.description'), 'description')}
                <TextField
                    fullWidth
                    id="description"
                    name="description"
                    placeholder={intl.get('calendarEventForm.placeholder.description')}
                    value={input.description}
                    onChange={handleInputChange}
                    error={!!errors.description}
                    size="small"
                />
            </Box>
            <Box sx={{ mb: 2 }}>
                {renderLabel(intl.get('calendarEventForm.date'), 'date')}
                <DatePickerDialog
                    disabled={false}
                    inputName="date"
                    className={'timesheet-datepicker'}
                    selected={input.date ? uniformizeDate(input.date) : ''}
                    setSelected={handleDate}
                    required
                />
            </Box>
        </Box>
    );
};

export default CalendarEventForm;